<template>
  <nav aria-label="Paginação pt-5">
    <ul class="pagination mt-4 justify-content-center">
      <li :class="['page-item', (pagina <= 1 ? 'disabled' : '')]">
        <template v-if="link_base">
          <router-link class="page-link" @click="paginacao(pagina - 1)"
            :to="link_base + (pagina - 1)">Anterior</router-link>
        </template>
        <template v-else>
          <button class="page-link" @click="paginacao(pagina - 1)">Anterior</button>
        </template>
      </li>
      <li class="page-item" v-for="(p, i) in range_pag" :key="i">
        <template v-if="link_base">
          <router-link :class="['page-link', (pagina == p ? 'active' : '')]" @click="paginacao(p)" :to="link_base + p">
            {{ p }}</router-link>
        </template>
        <template v-else>
          <button :class="['page-link', (pagina == p ? 'active' : '')]" @click="paginacao(p)">
            {{ p }}</button>
        </template>
      </li>
      <li :class="['page-item', (pagina == qtd_paginas || pagina == 0 ? 'disabled' : '')]">
        <template v-if="link_base">
          <router-link class="page-link" @click="paginacao(pagina + 1)"
            :to="link_base + (pagina + 1)">Próxima</router-link>
        </template>
        <template v-else>
          <button class="page-link" @click="paginacao(pagina + 1)">Próxima</button>

        </template>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Paginacao',
  props: {
    qtd_paginas: {
      default: 20
    },
    link_base: {
      default: null
    },
    pagina_prop: {
      default: 1
    },
  },
  data() {
    return {
      listagem: 1,
      categoria: '',
      pagina: 1,
      ativa_placeholder: true,
    }
  },
  computed: {
    range_pag: function () {
      var num_min = (this.pagina - 4)
      var num_max = (this.pagina + 4)
      if (this.qtd_paginas > 12) {
        var pags = []
        if (num_min > 1) {
          pags.push(1)
          for (let i = num_min; i < this.pagina; i++) {
            pags.push(i)
          }
        } else {
          for (let i = 1; i < this.pagina; i++) {
            pags.push(i)
          }
        }
        // pags.push(this.pagina)
        if (num_max < this.qtd_paginas) {
          for (let i = this.pagina; i < num_max; i++) {
            pags.push(i)
          }
          pags.push(this.qtd_paginas)
        } else {
          for (let i = this.pagina; i <= this.qtd_paginas; i++) {
            pags.push(i)
          }
        }
      } else {
        var pags = this.qtd_paginas
      }
      return pags;
    }
  },
  methods: {
    async paginacao(pag = 1) {
      if (this.pagina != pag) {
        this.pagina = pag
        this.$emit('paginar', pag)
      }
    },
  },
  mounted() {
    this.pagina = (this.pagina_prop - 1) + 1
  },
}
</script>

<style scoped></style>